document.addEventListener('DOMContentLoaded', function() {
  let instore = localStorage.getItem('instore');
  const url = new URL(window.location.href);
  if (url.searchParams.get('instore')) {
    instore = true;
  }
  
  if (instore) {
    document.cookie = 'instore=true; path=/';
  } else {
    document.cookie = 'instore=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
  }
  
  window.confirmPopupFlag = false;
  
  function resetTryOnStudio() {
    var t;
    
    function resetTimer() {
      clearTimeout(t);
      let instoreChange = localStorage.getItem('instore_change');
      if (window.confirmPopupFlag == false && instoreChange) {
        t = setTimeout(popupConfirm, window.resetTimeoutDuration);
      }
    }
    
    function popupConfirm() {
      window.confirmPopupFlag = true;
      console.log(window.confirmPopupFlag);
      if (window.confirmPopupFlag == true) {
        
        document.getElementById('customer-verification-modal').style.display = 'block';        
        let i = window.resetCountdownDuration;
        document.getElementById('customer-verification-content-data').textContent = 'TASH Studio will reset automatically in ' + i + ' seconds';        
        const myInterval = setInterval(myTimer, 1000);        
        function myTimer() {
          document.getElementById('customer-verification-content-data').textContent = 'TASH Studio will reset automatically in ' + i + ' seconds';
          i--;
          if (i < 0) {
            clearInterval(myInterval);            
            resetCookie();
          }  
        }
        
        const stillHereBtn = document.getElementById('still-here-btn');
        stillHereBtn.removeEventListener('click', closeModal);
        stillHereBtn.addEventListener('click', closeModal);
        
        const closeButtons = document.querySelectorAll('.close-modal');
        closeButtons.forEach(button => {
          button.removeEventListener('click', closeModal);
          button.addEventListener('click', closeModal);
        });
        
        window.removeEventListener('click', windowClick);
        window.addEventListener('click', windowClick);
        
        function windowClick(event) {
          if (event.target === document.getElementById('customer-verification-modal')) {
            closeModal();
          }
        }
        
        function closeModal() {
          document.getElementById('customer-verification-modal').style.display = 'none';
          clearInterval(myInterval);
          window.confirmPopupFlag = false;
        }
      }
    }
    
    window.onload = resetTimer;
    window.onmousemove = resetTimer;
    window.onmousedown = resetTimer;
    window.ontouchstart = resetTimer;
    window.ontouchmove = resetTimer;
    window.onclick = resetTimer;
    window.onkeydown = resetTimer;
    window.addEventListener('scroll', resetTimer, true);
  }
  
  function clearCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .catch(error => {
      console.error('Error clearing cart:', error);
    });
  }
  
  function resetCookie() {
        var a_all_cookies = document.cookie.split(';');
        for (i = 0; i < a_all_cookies.length; i++) {
            var a_temp_cookie = a_all_cookies[i].split('=');
            var cookie_name = a_temp_cookie[0].replace(/^\\s+|\\s+$/g, '');
            if (cookie_name.includes('_ga') || cookie_name.includes('_gid')) {
                var domain = '.' + window.location.hostname.replace(/^www\./, '');
                var path = '/';              
                console.log(cookie_name);
                console.log(domain);
                // Remove cookie for main domain
                document.cookie = cookie_name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=" + domain + "; path=" + path;
                
                // Remove cookie for Shopify preview/staging stores
                if (window.location.hostname.includes('myshopify.com')) {
                    var devDomain = '.' + window.location.hostname;
                    console.log(devDomain);
                    document.cookie = cookie_name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=" + devDomain + "; path=" + path;
                }
            }
        }
        try {
            console.log(window.GA_MEASUREMENT_ID);
            gtag('config', window.GA_MEASUREMENT_ID);
            gtag('event', 'session_end', { sessionControl: 'end' });
        } catch (e) {
            console.log('ga is not enabled')
        }
    let currentStore = localStorage.getItem('instore_name');
  
    sessionStorage.removeItem('current_selection');
    sessionStorage.removeItem('current_canvas');
    sessionStorage.removeItem('current_side');
    sessionStorage.clear();
    localStorage.clear();
    localStorage.setItem('instore', true);
    localStorage.setItem('instore_name', currentStore);
    localStorage.setItem('remove_cookie', true);
    
    clearCart().then(() => {
      console.log(Shopify);
      if (Shopify && typeof Shopify.logout === 'function') {
        Shopify.logout();
        window.location.reload();
      } else {
        console.log("Alternative");
        fetch('/account/logout', {
          method: 'GET',
          credentials: 'same-origin'
        }).then(function() {
         window.location.href = '/pages/TASH-Studio';
        }).catch(function(error) {
          console.error('Logout failed:', error);
        });
      }        
    });
  }
  
  function parseTimeoutDuration() {
    const timeoutSetting = window.instoreSettings.resetTimeoutDuration;
    const parsedTimeout = parseInt(timeoutSetting, 10);
    if (isNaN(parsedTimeout)) {
      console.warn('Invalid timeout duration. Using default 300 seconds.');
      return 300000; // Default 5 minutes in milliseconds
    }    
    return parsedTimeout * 1000; // Convert to milliseconds
  }
  function parseCountdownDuration() {
    const countdownSetting = window.instoreSettings.resetCountdownDuration;
    const parsedCountdown = parseInt(countdownSetting, 10);
    if (isNaN(parsedCountdown)) {
      console.warn('Invalid countdown duration. Using default 20 seconds.');
      return 20;
    }    
    return parsedCountdown;
  }
  
  if (instore) {
    window.resetTimeoutDuration = parseTimeoutDuration();
    window.resetCountdownDuration = parseCountdownDuration();
    resetTryOnStudio();
    function eventOccurs() {
      localStorage.setItem('instore_change', true);
    }
    const events = ['drag', 'focus', 'wheel', 'touchmove', 'mouseover', 'mouseout', 'click', 'mousedown', 'mouseup', 'touchstart', 'touchend', 'touchmove', 'touchcancel', 'dblclick', 'contextmenu'];
    events.forEach(event => {
      window.addEventListener(event, eventOccurs);
    });
  }
});